import React from 'react';

export function CloseButton() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M6.93 16.3534L11 12.2834L15.07 16.3534L16.3534 15.07L12.2834 11L16.3534 6.93L15.07 5.64658L11 9.71658L6.93 5.64658L5.64657 6.93L9.71658 11L5.64657 15.07L6.93 16.3534ZM11 22C9.49062 22 8.06676 21.7113 6.72843 21.1338C5.39009 20.5562 4.22281 19.7695 3.22658 18.7734C2.23053 17.7772 1.44375 16.6099 0.86625 15.2716C0.28875 13.9332 0 12.5094 0 11C0 9.47833 0.28875 8.04833 0.86625 6.71C1.44375 5.37167 2.23053 4.2075 3.22658 3.2175C4.22281 2.2275 5.39009 1.44375 6.72843 0.86625C8.06676 0.28875 9.49062 0 11 0C12.5217 0 13.9517 0.28875 15.29 0.86625C16.6283 1.44375 17.7925 2.2275 18.7825 3.2175C19.7725 4.2075 20.5562 5.37167 21.1338 6.71C21.7113 8.04833 22 9.47833 22 11C22 12.5094 21.7113 13.9332 21.1338 15.2716C20.5562 16.6099 19.7725 17.7772 18.7825 18.7734C17.7925 19.7695 16.6283 20.5562 15.29 21.1338C13.9517 21.7113 12.5217 22 11 22Z"
        fill="black"
      />
    </svg>
  );
}
